<template>
  <div>
    <b-card bg-variant="dark" text-variant="white" class="text-center my-4">
      <div class="book-detail">
        <div class="image-wrapper">
          <img v-bind:src="book.imageURL" :title="book.bookTitle" />
        </div>
        <div>
          <b-card-text>{{ book.bookTitle }}</b-card-text>
          <b-card-text>{{ book.author }}</b-card-text>
          <div v-if="$store.getters.isSignedIn">
            <b-button
              variant="warning"
              class="p-1 m-2"
              @click="deleteFromUserbooks(bookId)"
              v-if="isMyBook"
            >
              myBooksに登録済み
            </b-button>
            <b-button
              variant="outline-warning"
              class="p-1 m-2"
              @click="saveMyBook"
              v-else
              >myBooksに登録</b-button
            >
          </div>
          <b-card-text>{{ book.description }}</b-card-text>
        </div>
      </div>
    </b-card>

    <QuestionPost :bookId="bookId" :bookImage="book.imageURL" v-if="isMyBook" />

    <b-tabs content-class="mt-3" align="center">
      <b-tab v-if="myQuestionObjs.length != 0" title="自分の問い" active>
        <div
          class="question-wrapper"
          v-for="(question, index) in myQuestionObjs"
          :key="index"
        >
          <!-- 問いのカード -->
          <QuestionCard :question="question" />
        </div>
      </b-tab>

      <b-tab title="みんなの問い">
        <p v-if="otherQuestionObjs.length == 0">
          みんなの問いはまだありません。
        </p>

        <div
          class="question-wrapper"
          v-for="(question, index) in otherQuestionObjs"
          :key="index"
        >
          <!-- 問いのカード -->
          <QuestionCard :question="question" />
        </div>
      </b-tab>

      <b-tab title="お気に入りの問い">
        <p v-if="favQuestionsObjs.length == 0">
          お気に入りの問いはまだありません。
        </p>
        <div
          class="question-wrapper"
          v-for="(question, index) in favQuestionsObjs"
          :key="index"
        >
          <!-- 問いのカード -->
          <QuestionCard :question="question" @data-updated="fetchBook" />
        </div>
      </b-tab>
    </b-tabs>
  </div>
  <!-- http://localhost:8080/book/1MNQ1EU1QyX9JMvaN3mm -->
</template>

<script>
import { db } from "@/firebase";
import QuestionPost from "@/components/QuestionPost.vue";
import QuestionCard from "@/components/QuestionCard.vue";
export default {
  data: function() {
    return {
      book: {},
      bookId: this.$route.params.bookId,
      //問い用のプロパティ
      myQuestionObjs: [],
      favQuestionsObjs: [],
      otherQuestionObjs: [],
      isMyBook: this.$store.getters.isSignedIn
        ? this.$store.getters.user.books.includes(this.$route.params.bookId)
        : false
    };
  },
  components: {
    QuestionPost,
    QuestionCard
  },
  methods: {
    fetchBook() {
      // オブジェクトの初期化
      this.myQuestionObjs = [];
      this.otherQuestionObjs = [];
      db.collection("books")
        .doc(this.bookId)
        .get()
        .then(snapshot => {
          this.book = snapshot.data();
          console.log(snapshot.data());
          // 本が持つ問いを取得
          snapshot.data().questions.forEach(questionId => {
            let questionObj = {};
            db.collection("questions")
              .doc(questionId)
              .get()
              .then(snapshot => {
                questionObj = snapshot.data();
                questionObj.id = questionId;
                // コメント（サブコレクション）を取得
                db.collection("questions")
                  .doc(questionId)
                  .collection("comments")
                  .orderBy("createdAt", "desc")
                  .limit(3)
                  .get()
                  .then(comments => {
                    const commentsArray = [];
                    comments.docs.forEach(comment => {
                      commentsArray.push(comment.data());
                    });
                    if (commentsArray.length != 0) {
                      questionObj.comments = commentsArray;
                    }
                    if (this.$store.getters.isSignedIn) {
                      // 自分の問い
                      if (questionObj.user == this.$store.getters.user.id) {
                        this.myQuestionObjs.push(questionObj);
                        // お気に入りの問い
                      } else if (
                        this.$store.getters.user.favQuestions.includes(
                          questionId
                        )
                      ) {
                        this.favQuestionsObjs.push(questionObj);
                        // その他の問い
                      } else {
                        this.otherQuestionObjs.push(questionObj);
                      }
                    } else {
                      this.otherQuestionObjs.push(questionObj);
                    }
                  });
              });
          });
        });
    },
    deleteFromUserbooks(id) {
      const userbooks = this.$store.getters.user.books;
      userbooks.forEach((bookId, index) => {
        if (bookId == id) {
          userbooks.splice(index, 1);
        }
      });
      this.$store.dispatch("updateUserData", { books: userbooks });
      this.isMyBook = false;
    },
    saveMyBook() {
      const books = this.$store.getters.user.books;
      if (!books.includes(this.bookId)) {
        books.push(this.bookId);
        this.$store.dispatch("updateUserData", { books: books });
        this.isMyBook = true;
      } else {
        window.alert("既にmybookに登録してあります。");
      }
    }
  },
  created() {
    this.fetchBook();
  }
};
</script>

<style lang="scss">
.book-detail {
  display: flex;
  flex-direction: row;
}
</style>
